export function SpeciesSelectorIntro() {
  return (
    <div className='text-center lg:text-left'>
      <h1 className='font-heading text-3xl font-bold leading-tight tracking-tight text-foreground sm:text-4xl'>
        Your <span className='text-primary-600'>forever friend</span> awaits you
      </h1>
      <p className='mt-4 text-base leading-relaxed text-muted-foreground sm:text-lg'>
        We don&apos;t just find pets, we curate lifelong companions. Start your
        journey by choosing your future teammate.
      </p>
    </div>
  );
}
